<template>
  <v-icon :class="{ 'material-symbols-outlined': isMDLib }" :color="color" :size="size">
    {{ icon }}
  </v-icon>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: '',
    },

    lib: {
      type: String,
      default: 'mdi',
      validator: (val) => ['mdi', 'md'].includes(val),
    },

    color: {
      type: String,
      default: undefined,
    },

    size: {
      type: String,
      required: false,
    },
  },
  computed: {
    isMDLib() {
      return this.lib === 'md' || this.icon.startsWith('md:');
    },
  },
};
</script>
